const Main = () => import('./Main')

const route = {
  path: '/about',
  name: 'about',
  meta: {
    title: 'About - A D M A N 2 0 1 9'
  },
  component: Main
}

export default route
